(function () {
  'use strict';

  /**
   * @author Dahang Xu
   * @description  Semafone PCI Tokenise Service
   * @class ute-ui
   * @memberOf ute-ui
   */

  angular.module('ute.ui')
    .factory('uteSemafonePCITokeniseService', _service);

  _service.$inject = ['env', '$http', 'permissionsService'];

  /* @ngInject */
  function _service(env, $http, permissionsService) {

    var pciTokeniseUrl = env.fidoHomePageUrl + env.semafoneParameters.moneris.pciTokeniseURL;

    var service = {
      getMaskCardNumber: getMaskCardNumber
    };

    return service;

    function semafoneRequestXML(token) {
      var xmlRequest = '<?xml version="1.0" encoding="UTF-8"?>' +
        '<ns2:retailTokenisationRequest xmlns:ns2="http://www.semafone.com/rogers/cde/cash" xmlns="http://www.semafone.com">';
      xmlRequest += '<ns2:cardReaderOutput>' + token + '</ns2:cardReaderOutput>';
      xmlRequest += '<ns2:cardReaderType>IDTECH_SECUREMAG_80096504_001_L</ns2:cardReaderType></ns2:retailTokenisationRequest>';

      return xmlRequest;
    }

    function getMaskCardNumber(encryptString, _callback) {

      var req = semafoneRequestXML(encryptString);
      var _result = {};
      xmlHttpPost(pciTokeniseUrl, req).then(function (data) {
        if (data) {
          _result.result = 'success';
          _result.data = data.data;
          return _callback(_result);
        } else {
          _result.result = 'fail';
          _result.data = data;
          return _callback(_result);
        }

      }, function (error) {

        _result.result = 'error';
        _result.data = error;
        return _callback(_result);
      });
    }

    function xmlHttpPost(endpoint, params) {

      var request = {
        method: params.httpMethod || 'POST',
        url: endpoint,
        headers: {
          'Content-Type': 'text/xml'
        },
        data: params,
        cache: angular.isDefined(params.cache) ? params.cache : false
      };

      console.log('-- "' + endpoint + '" REQUEST: ', request);
      return $http(request);
    }
  }
})();
